// extracted by mini-css-extract-plugin
export default {"main":"Toast_main__TXxor","fadein":"Toast_fadein__fgbxi","fadeout":"Toast_fadeout__YkCgw"};